export class CalendarCell {
    courseId: string;
    courseLeter: string;
    subjectId: string;
    subjectName: string;
    subjectShortName: string;
    teacherName:string;
}